import $ from 'jquery';
import Cookies from 'js-cookie';
import axios from 'axios';

var cookiesAcceptedInScrolling = false;
var extraDaysCookies = 1825;

$(document).ready(function () {
  cookiesAcceptedInScrolling = true;

  const $cookiesWarning = $('.e-cookies-warning');
  const cookiesAccepted = Cookies.get('cookies-accepted');

  addExternalTracking();
  setCookie('1');

  function initFacebook(fbqid) {
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () {
        n.callMethod ?
          n.callMethod.apply(n, arguments) : n.queue.push(arguments)
      }; if (!f._fbq) f._fbq = n;
      n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = []; t = b.createElement(e); t.async = !0;
      t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s)
    }(window,
      document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', fbqid);
    fbq('track', 'PageView');
  }

  function getFacebookId() {
    var apiUrl = window.location.origin + "/common/pagateliaSettings/getPagateliaSettingByKey/FacebookId";
    axios.get(apiUrl).then(function (response) {
      if (response.data.data != undefined && response.data.data.settingValue != undefined) {
        initFacebook(response.data.data.settingValue);
      }
    })
  }

  function getCookie(cookie) {
    return Cookies.get(cookie);
  }

  function setCookie(value) {
    var expireDate = getExpireDateCookie();

    $.ajax({
      type: "GET",
      url: "/common/getdomain",
      dataType: "text",
      retryLimit: 3,
      success: function (data) {
        setCookieValue('cookies-accepted', value, data, expireDate);
        $cookiesWarning.removeClass('not-accepted');
        if (value == '1') {
          addExternalTracking();
        }
      },
      error: function () {
        this.retryLimit--;
        if (this.retryLimit) {
          //try again
          $.ajax(this);
          return;
        }

        setCookieValue('cookies-accepted', value, null, expireDate);
      }
    });
  }

  function addExternalTracking() {
    getFacebookId();
  }

  function isLocalHost(domain) {
    return domain == null || domain == undefined || domain.toString().toLowerCase() == 'localhost'.toString() || domain.toString() == ''.toString();
  }

  function getExpireDateCookie() {
    return extraDaysCookies;
  }

  function setCookieValue(name, value, domain, expireDate) {
    var islocalhost = isLocalHost(domain);
    if (islocalhost)
      Cookies.set(name, value, { path: '/', expires: expireDate, secure: true });
    else
      Cookies.set(name, value, { path: '/', domain: domain, expires: expireDate, secure: true });
  }

});



// WEBPACK FOOTER //
// ./app/ui/elements/cookies-warning/index.js